module.exports = __webpack_public_path__ + "static/img/5006_phase_function_Paper_PointsHejduk_Prediction.b31ef61.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5006_phase_function_Paper_PointsHejduk_Prediction.png
// module id = C2TT
// module chunks = 0